let slots,
	mainViewThreshold;

const DEFAULT_THRESHOLD = 300;

function init(lazyLoadThreshold = DEFAULT_THRESHOLD) {
	mainViewThreshold = lazyLoadThreshold;
	slots = [];

	if (typeof mainViewThreshold !== 'number' || isNaN(mainViewThreshold)) {
		mainViewThreshold = DEFAULT_THRESHOLD;
	}

	window.advert.pubsub.subscribe('scroll', _renderSlotsInView);
}

function _getThreshold(slot) {
	const threshold = typeof slot.lazyLoadThreshold === 'undefined' ? mainViewThreshold : parseInt(slot.lazyLoadThreshold, 10);

	if (typeof threshold !== 'number' || isNaN(threshold)) {
		return mainViewThreshold;
	}

	return threshold;
}

function addSlot(/** Slot */ slot) {
	if (!slot.lazyLoaded) {
		slot.render();

		return;
	}

	slots.push(slot);

	_renderSlotsInView();
}

function _renderSlotsInView() {
	slots = slots.filter((/** Slot */ slot) => {
		if (window.advert.screen.isInView(slot.node, _getThreshold(slot))) {
			slot.render();

			return false;
		}

		return true;
	});
}

module.exports = {
	init,
	addSlot
};
